import { useNgSession } from "@sazka/ng/ng-session";
import { GamingLimits } from "@/registration/models/gaming-limits";
import { ref } from "vue";

export enum RgLabel {
    noLimit = "noLimit",
    setLimit = "setLimit",
    hint = "hint",
    otherOptions = "otherOptions",
    excludeMe = "excludeMe",
    confirm = "confirm",
}

export enum RgCategory {
    netLossPerDay = "netLossPerDay",
    netLossPerMonth = "netLossPerMonth",
    numberOfLoginsPerMonth = "numberOfLoginsPerMonth",
    loginTimePerDay = "loginTimePerDay",
    pauseAfterLogOut = "pauseAfterLogOut",
    highestBetPerDay = "highestBetPerDay",
    highestBetPerMonth = "highestBetPerMonth",
    permanentExclusionFromGame = "permanentExclusionFromGame",
}

export enum RgFrom {
    loginBar = "loginBar",
    myAccount = "myAccount",
    playResponsibly = "playResponsibly",
}

export const launchedFrom = ref(RgFrom.myAccount);
export const isRgLimitsOpen = ref(false);

export const getRgCategory = (key: keyof GamingLimits) => {
    switch (key) {
        case "lossDaily":
            return RgCategory.netLossPerDay;
        case "lossMonthly":
            return RgCategory.netLossPerMonth;
        case "loginCount":
            return RgCategory.numberOfLoginsPerMonth;
        case "loginDuration":
            return RgCategory.loginTimePerDay;
        case "coolOffTime":
            return RgCategory.pauseAfterLogOut;
        case "spendingDaily":
            return RgCategory.highestBetPerDay;
        case "spendingMonthly":
            return RgCategory.highestBetPerMonth;
    }
};

export namespace RgLimitsAnalytics {
    const { session } = useNgSession();

    export const pushRgLimitsPopup = () => {
        window.dataLayer.push({
            page: {
                type: "account.widget",
                kind: "widget.setGameLimit",
            },
            user: {
                id: session.value.PlayerID,
            },
            event: "page",
        });
    };

    // DL5.00, DL5.10, DL5.20, DL5.30
    export const pushRgLimitsButtonClick = (label: RgLabel, category?: RgCategory) => {
        window.dataLayer.push({
            event: "action.click.gamingLimits",
            action: {
                click: {
                    label: label, // click type
                    eventProperty1: launchedFrom.value, // which path led to widget
                    eventProperty2: category, // gaming limit category
                },
            },
        });
    };

    export const pushPermanentExclusionFromGame = () => {
        if (isRgLimitsOpen.value) pushRgLimitsButtonClick(RgLabel.confirm, RgCategory.permanentExclusionFromGame);
    };

    //DL1.50
    export const pushShowRgLimitsBar = (text: string) => {
        window.dataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: "limitsBar",
                            name: "limitsBar",
                            creative: text,
                            position: "bottom",
                        },
                    ],
                },
            },
        });
    };

    //DL1.51
    export const pushClickRgLimitsBar = (text: string) => {
        window.dataLayer.push({
            event: "action.show.promos",
            action: {
                show: {
                    promos: [
                        {
                            id: "limitsBar",
                            name: "limitsBar",
                            creative: text,
                            position: "bottom",
                        },
                    ],
                },
            },
        });
    };
}
